export const RECEIVED_NOT_BANKED = 'RE';
export const CANCELLED = 'CN';
